import { Link } from 'react-router-dom';

export default function HandbookPage() {
    return (
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
            {/* Header */}
            <div className="text-center mb-8 animate-fade-in">
                <div className="inline-block bg-primary-950 text-primary-300 border border-primary-500/30 px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-2">
                    Official Program Policy
                </div>
                <h1 className="text-3xl sm:text-4xl md:text-5xl font-display font-extrabold text-white mb-3">
                    Esports <span className="text-primary-500">Handbook</span>
                </h1>
                <p className="text-secondary-300 text-base sm:text-lg">Fall 2026 Season • Peck Community Schools</p>
                <p className="text-secondary-400 text-xs mt-1">
                    Aligned with the Peck Community Schools Athletic Handbook & District Board Policies
                </p>

                {/* PDF Download Button */}
                <div className="mt-4">
                    <a
                        href="/documents/Peck_Pirates_Esports_Fall_2026_Packet.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Download Full Season Packet PDF including Handbook and Code of Conduct (opens in new tab)"
                        className="bg-primary-600 hover:bg-primary-500 text-white font-bold text-xs px-4 py-2.5 rounded-lg transition-colors inline-flex items-center gap-2 shadow-md focus-visible:ring-2 focus-visible:ring-primary-400 focus-visible:outline-none"
                    >
                        <span>📄 Download Full Season Packet PDF (Handbook + Code of Conduct + Forms)</span>
                        <span aria-hidden="true">↗</span>
                    </a>
                </div>

            </div>

            {/* Mission & Vision */}
            <section className="card mb-6 p-6 bg-secondary-900 border-secondary-700 animate-slide-up">
                <h2 className="text-xl font-display font-bold text-primary-400 mb-3">
                    I. Mission & Vision
                </h2>
                <p className="text-secondary-300 text-sm leading-relaxed">
                    The Peck Pirates Esports program provides a varsity-level competitive environment for students to develop teamwork, digital citizenship, strategic thinking, and STEM skills through competitive gaming and digital broadcasting. We emphasize <strong className="text-white">"Gaming with Intention,"</strong> aligning student passion with academic and behavioral excellence.
                </p>
            </section>

            {/* Academic Eligibility */}
            <section className="card mb-6 p-6 bg-secondary-900 border-secondary-700 animate-slide-up">
                <h2 className="text-xl font-display font-bold text-primary-400 mb-4">
                    II. Academic Eligibility (Athletic Handbook Alignment)
                </h2>
                <ul className="space-y-3 text-sm text-secondary-300">
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">No "E" Policy:</strong> Academic eligibility checks run Friday to Friday per Athletic Handbook standard AH0112. A failing grade results in a one-week suspension from official matches.</span>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Physical Exam:</strong> No sports physical exam is required for esports participation.</span>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Grades 8–12:</strong> Open to high school students and eligible 8th graders (ages 13+).</span>
                    </li>
                </ul>
            </section>

            {/* Attendance & Dual-Sport Policy */}
            <section className="card mb-6 p-6 bg-secondary-900 border-secondary-700 animate-slide-up">
                <h2 className="text-xl font-display font-bold text-primary-400 mb-4">
                    III. Attendance & Dual-Sport Participation
                </h2>
                <ul className="space-y-3 text-sm text-secondary-300">
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Dual-Sport Athletes:</strong> Peck Esports actively supports multi-sport athletes. Coaches coordinate schedules to prevent conflicts with football, cross country, or cheer.</span>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">School Day Attendance:</strong> Athletes must be in attendance at school on match days to compete. Absences must be reported to the school office or coach by 10:00 AM.</span>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Competition Commitment:</strong> Team members are expected to communicate any schedule conflicts with Coach Anklam in advance.</span>
                    </li>
                </ul>
            </section>

            {/* Equipment & Lab Policies */}
            <section className="card mb-8 p-6 bg-secondary-900 border-secondary-700 animate-slide-up">
                <h2 className="text-xl font-display font-bold text-primary-400 mb-4">
                    IV. Equipment & Technology
                </h2>
                <ul className="space-y-3 text-sm text-secondary-300">
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Lab Gear:</strong> 6 dedicated gaming PCs with RTX 5060 GPUs, Nintendo Switch setups, broadcast switcher, and studio microphones are provided.</span>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Bring Your Own Device (BYOD):</strong> Smash Bros players may bring their personal Nintendo Switch consoles or controllers with coach approval to expand tournament capacity.</span>
                    </li>
                    <li className="flex items-start gap-2.5">
                        <span className="text-primary-400 font-bold">•</span>
                        <span><strong className="text-white">Account Safety:</strong> Modified consoles, hacked software, or unauthorized account sharing is strictly prohibited in all sanctioned MiHSEF matches.</span>
                    </li>
                </ul>
            </section>

            {/* Navigation */}
            <div className="flex justify-between items-center pt-4 border-t border-secondary-800">
                <Link to="/conduct" className="btn-secondary text-sm">
                    ← Code of Conduct
                </Link>
                <Link to="/parents" className="btn-primary text-sm">
                    Parents Guide →
                </Link>
            </div>
        </div>
    );
}

